// extracted by mini-css-extract-plugin
export var dataCell = "_qz-2";
export var dataRow = "_qz-0";
export var headerRow = "_qz-1";